<template>
    <div class="post-container" v-dragscroll.y="true" :class="{opened: opened, mobile: mobile}" >
       
        
        <div v-if="currentPost" class="post-container_controlls">
            <button @click="opened = !opened" area-label="close" class="close">
                <img :src="`${url}/wp-content/themes/leo-wacker/dist/img/icons/maps.svg`">
            </button>
            <div class="button type-2 green" 
            data-send-object
            :data-title="currentPost.name"
            :data-id="currentPost.id"
            :data-price="currentPost.price"
            :data-unique-id="currentPost.unique_id"
            :data-link="currentPost.link"
            >{{translations.send[locale]}}</div>
        </div>
       
        <div v-if="currentPost" class="post-container_content">
            <div class="post-container_header">
                <div class="post-container_header-title">
                    <p class="location">{{translations.berlin[locale]}} - {{currentPost.area}}<span v-if="currentPost.type_name">, {{`${currentPost.type_name}`}}</span></p>
                    <h1>{{currentPost.name}}</h1>
                </div>
                <div class="post-container_header-price">
                    {{Number(currentPost.price).toLocaleString("es-ES", {minimumFractionDigits: 0})}} €
                </div>
            </div>
            <!-- <div class="reserved" v-show="currentPost.reserved">{{status}}</div> -->
            <Carousel v-if="currentPost.gallery_large.length"
            :perPage="1" 
            :navigationEnabled="true" 
            :paginationActiveColor="'#ffffff'" 
            :paginationColor="'rgba(255,255,255,.4)'"
            :paginationPadding="0"
            :paginationSize="8" >
                <Slide>
                    <a data-auto-focus="false" :data-fancybox="`gallery_${currentPost.id}`" :data-caption="getCaption()" :rel="`gallery_${currentPost.id}`" :href="currentPost.thumbnail_large" class="object-item_image">
                        <div class="reserved" v-show="currentPost.reserved">{{status}}</div>
                        <img :src="currentPost.thumbnail_large" :alt="currentPost.name">
                    </a>
                </Slide>
                <Slide v-for="image in currentPost.gallery_large" :key="image">
                    <a data-auto-focus="false"  :data-caption="getCaption()" :data-fancybox="`gallery_${currentPost.id}`" :rel="`gallery_${currentPost.id}`" :href="image" class="object-item_image">
                        <div class="reserved" v-show="currentPost.reserved">{{status}}</div>
                        <img :src="image" :alt="currentPost.name">
                    </a>
                </Slide>
            </Carousel>
            <a data-auto-focus="false" :data-fancybox="`gallery_${currentPost.id}`" :rel="`gallery_${currentPost.id}`" :href="currentPost.thumbnail_large" v-else class="object-item_image">
                <img :src="currentPost.thumbnail_large" :alt="currentPost.name">
            </a>
            <div class="post-container_info">
                <div class="living-space">
                    {{currentPost.living_space}} m<sup>2</sup>
                </div>
                <div class="rooms">
                    {{currentPost.room}} {{declOfNum(currentPost.room, translations.zimmers[locale])}}
                </div>
            </div>
             <div v-html="postHTML"></div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
//
import { dragscroll } from 'vue-dragscroll'

export default {
    props: {
        postData: {
            type: Object,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        objects: {
            type: Array,
            required: true
        },
        locale: {
            type: String,
            required: true
        },
        translations: {
            type: Object,
            required: true
        },
        mobile: {
            type: Boolean,
            required: true
        }
    },
    directives: {
        'dragscroll': dragscroll
    },
    components: {
        Carousel, 
        Slide
    },
    data() {
        return {
            postHTML: null,
            opened: false,
            status: ''
        }
    },
    mounted() {
        this.status = this.translations.reservedItem[this.locale];
    },
    methods: {
        async loadPost(){
            //console.log('load');
            const mapWrap = document.querySelector('.mapboxgl-canvas-container');
            mapWrap.classList.add('loading');
            //this.opened = true;
            // const response = await fetch(`${this.url}/wp-json/wp/v2/object/${this.postData.id}`);
            const response = await fetch(`${this.url}/wp-json/objects-list/v1/contents/${this.postData.id}`);
            const data = await response.json();
            this.postHTML = JSON.parse(data).html;
            this.postData.loading = false;
            this.opened = true;

            
            mapWrap.classList.remove('loading');
            document.title = this.currentPost.name;
            window.history.pushState({"html":'',"pageTitle":this.currentPost.name},"", this.currentPost.link);
            console.log(this.currentPost.link);
        },
        declOfNum(numberRaw, titles) {
            const number = Math.round(numberRaw);
            const cases = [2, 0, 1, 1, 1, 2];
            return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
        },

        getCaption() {
            let string = this.currentPost.reserved ? `<div class="reserved" >${this.status}</div>` : '';
            return string;
        }
    },
    computed: {
        isOpen() {
            let opened;
            if(!this.postData.loading && this.opened){
                opened = true
            } else {
                opened = false
            }
            return opened
        },
        currentPost () {
            return this.objects.find((obj) => {
                return obj.id == this.postData.id
            })
        }
    },
    watch: {
        postData: function() {
            // if(val.id != oldVal.id){
            //console.log(val.id != oldVal.id);
            this.opened = false;
            this.loadPost();
            
        }
    }
}
</script>
<style scoped>
.reserved {
    position: relative;
}
.post-container {
    position: absolute;
    right: 0;
    top: 0;
    width: 50vw;
    height: 100%;
    transform: translate3d(100%, 0, 0);
    transition: .25s ease-out;
    background-color: #EEF2F6;
    padding: 1rem;
    overflow-y: scroll;
    z-index: 99;
}
.post-container_content .object-item_image::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: 3.5rem;
    height: 3.5rem;
    border-radius: .32rem;
    transform: translate(-50%, -50%);
    background: rgba(0,0,0, .7);
    z-index: 2;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' version='1.1' width='512' height='512' x='0' y='0' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512' xml:space='preserve' class=''%3E%3Cg%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath d='M496.64,424.96l-71.68-71.68c23.04-35.84,35.84-76.8,35.84-122.88C460.8,102.4,358.4,0,230.4,0S0,102.4,0,230.4 s102.4,230.4,230.4,230.4c46.08,0,87.04-12.8,122.88-35.84l71.68,71.68c20.48,20.48,51.2,20.48,71.68,0 C517.12,476.16,517.12,445.44,496.64,424.96z M230.4,409.6c-99.84,0-179.2-79.36-179.2-179.2S130.56,51.2,230.4,51.2 s179.2,79.36,179.2,179.2S327.68,409.6,230.4,409.6z' fill='%23ffffff' data-original='%23000000' style='' class=''/%3E%3C/g%3E%3C/g%3E%3Cg xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath d='M332.8,204.8H256V128c0-15.36-10.24-25.6-25.6-25.6c-15.36,0-25.6,12.8-25.6,25.6v76.8H128c-12.8,0-25.6,10.24-25.6,25.6 c0,15.36,10.24,25.6,25.6,25.6h76.8v76.8c0,15.36,10.24,25.6,25.6,25.6c15.36,0,25.6-10.24,25.6-25.6V256h76.8 c15.36,0,25.6-10.24,25.6-25.6C358.4,215.04,345.6,204.8,332.8,204.8z' fill='%23ffffff' data-original='%23000000' style='' class=''/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-size: 1.6rem;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0;
    transition: opacity .25s ease-out;
    will-change: transform;
    pointer-events: none;
}
.post-container_content .object-item_image:hover::before {
    opacity: 1;
}
.post-container.mobile {
    position: fixed;
    left: 0;
    top: 2rem;
    width: 100%;
    height: calc(100% - 2rem);
    z-index: 9999;
    padding-top: 0;
    background: #fff;
    overflow: hidden !important;
}
.post-container.opened {
    transform: translate3d(0,0,0);
    overflow-y: scroll;
    overflow-x: hidden;
}
.post-container_header {
    display: flex;
    padding-bottom: 1.5rem;
}
.post-container_header-title {
    width: 80%;
}
.post-container_header-price {
    width: 20%;
    font-size: 2rem;
    font-weight: bold;
    text-align: right;
    padding-top: 1.6rem;
    white-space: nowrap;
}
.post-container_header-title > *{
    font-size: 2.18rem;
    font-family: 'Cormorant Garamond';
}
.post-container_header-title .location {
    color: #767676;
    text-transform: uppercase;
    font-size: 1.25rem;
}
.post-container_info {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    font-size: 1.88rem;
    font-family: 'Cormorant Garamond';
    padding: 1rem 0;
    position: relative; 
}
.post-container_info::after {
    content: '';
    position:absolute;
    left: -1rem;
    top: 100%;
    width: calc(100% + 2.2rem);
    height: 1px;
    background-color: #E0E0E0;
}
.post-container_info .rooms {
    padding-left: 2rem;
}
.VueCarousel {
    width: 100%;
}
.close {
    width: 3.3rem;
    height: 2.68rem;
    cursor: pointer;
    -webkit-appearance: none;
    border: none;
    outline: none;
    background-color: transparent;
    position: relative;
}
.close img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
}
/* .close::after,
.close::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    background: #000;
}
.close::after {
    transform: rotate(45deg);
}
.close::before {
    transform: rotate(-45deg);
} */
.post-container_controlls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 2rem;
}
.mobile .post-container_controlls {
    padding: 0.7rem 0;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 1;
}
.mobile .post-container_controlls::after {
    content: '';
    position: absolute;
    left: -2rem;
    top: 100%;
    width: calc(100% + 4rem);
    height: 1px;
    background: rgba(0,0,0, .1);
}
.mobile .post-container_header {
    padding-top: 2rem;
    display: block;
}
.mobile .post-container_header-title {
    width: 100%;
}
.mobile .post-container_header-title  > * {
    font-size: 1.8rem;
}
.mobile .post-container_header-title  .location {
    font-size: 0.8rem;
}
.mobile .post-container_header-price {
    font-size: 1.5rem;
    width: 100%;
}
.mobile.post-container .object-item_image{
    width: 100%;
}
.mobile.post-container .object-item_image::before{
    opacity: 1;
    left: 100%;
    top: 0;
    width: 2.5rem;
    height: 2.5em;
    background-size: 1.1rem;
    transform: translate(calc(-100% - .3rem),.3rem);
}
.mobile .post-container_info {
    justify-content: flex-start;
}
.mobile .post_fields-wrap {
    display: block;
}
</style>